import React, {useMemo, useRef, useState} from "react";
import User from "../../models/User";
import debounce from "lodash/debounce";
import UserImageCircle from "../UserImageCircle";
import {Empty, Select, Spin} from "antd";
import {useAPI} from "../../config/API";


const SearchTalentInput = ({debounceTimeout = 800, perPage = 15, params = {}, onChange, formatOption, isDisabled, inputValue: value, ...props}) => {

    const [options, setOptions] = useState([]);
    const [defaultOptions, setDefaultOptions] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const fetchRef = useRef(0);
    const [fetchId, setFetchId] = useState(0);

    const {
        data: candidateMatches,
        isFetching,
        isRefetching,
        error,
        refetch,
    } = useAPI(['searchCandidates', {
            search: searchValue,
            ...params,
            per_page: perPage
        }], {
            onSuccess: result => {
                console.log('onSuccess', result)
                let mappedOptions = getOptions(
                    User.makeMany(result.users || []),
                    searchValue,
                    result.total || 0
                );
                if (!defaultOptions?.length) {
                    setDefaultOptions(mappedOptions)
                }
                setOptions(mappedOptions);
                setIsLoading(false)
            },
        }
    )

    const debounceFetcher = useMemo(() => {
        // setIsLoading(true)
        const loadOptions = (value) => {
            setOptions([]);
            setSearchValue(value)
        };
        return debounce(loadOptions, debounceTimeout);
    }, [debounceTimeout]);

    const getOptions = (users = [], highlight = '', total) => {
        let highLightText = (text) => {
            if (!highlight?.length) {
                return text
            }
            const re = new RegExp(highlight, "gi");

            return text.replace(re, '<span class="font-semibold bg-warning text-black">$&</span>')
        }

        let mappedOptions = TB.map(users, member => {
            if (formatOption) {
                return formatOption(member)
            }
            return {
                key: member.id,
                value: member.id,
                // disabled: !member.is_active,
                user: member,
                title: member.fullName(),
                label: (
                    <span className="flex flex-row items-center gap-2">
                        <UserImageCircle user={member} size={28}/>
                        <span dangerouslySetInnerHTML={{__html: highLightText(member.fullName())}}/>

                        <small className="ml-2">
                            <span dangerouslySetInnerHTML={{__html: highLightText(member.email)}}/>
                        </small>
                    </span>
                )
            }
        })
        if (total && (total - perPage) > 0) {
            mappedOptions.push({
                disabled: true,
                key: `totals-${total}`,
                value: `totals-${total}`,
                label: (
                    <span className="flex flex-row justify-center items-center gap-2">
                        <span className="italic text-info text-center font-semibold text-xs">
                            Showing Top {perPage} results...
                        </span>
                    </span>
                )
            })
        }
        return mappedOptions
    }

    return (
        <Select
            labelInValue={true}
            showSearch={true}
            autoClearSearchValue={true}
            onSelect={() => {
                setOptions([])
            }}
            filterOption={false}
            allowClear={true}
            onSearch={debounceFetcher}
            loading={isFetching}
            notFoundContent={isFetching ? <Spin size="small"/> : <Empty className="my-3.5" image={Empty.PRESENTED_IMAGE_SIMPLE} description="No users found" />}
            options={options}
            value={value}
            onChange={onChange}
            {...props}
        >

        </Select>
    );
}

export default SearchTalentInput